import React from 'react'

import CampusSvg from 'components/atoms/SVGIcons/NewIcons/Campus'
import ScholarshipSvg from 'components/atoms/SVGIcons/NewIcons/Scholarship'
import MajorSvg from 'components/atoms/SVGIcons/NewIcons/Major'
import CareerSvg from 'components/atoms/SVGIcons/NewIcons/Career'
import AptitudeSvg from 'components/atoms/SVGIcons/NewIcons/Aptitude'
import KampuspediaSvg from 'components/atoms/SVGIcons/NewIcons/Kampuspedia'
import LearnSvg from 'components/atoms/SVGIcons/NewIcons/Learn'
import PaperplaneSvg from 'components/atoms/SVGIcons/NewIcons/Paperplane'
import InterestSvg from 'components/atoms/SVGIcons/NewIcons/Interest'
import LogoutSvg from 'components/atoms/SVGIcons/NewIcons/Logout'
import ArrowLeftSvg from 'components/atoms/SVGIcons/ArrowLeft'
import City from 'components/atoms/SVGIcons/NewIcons/City'
import Province from 'components/atoms/SVGIcons/NewIcons/Province'
import RightSvg from 'components/atoms/SVGIcons/Right'
import HomeSVG from 'components/atoms/SVGIcons/Home'
import HomeActiveSVG from 'components/atoms/SVGIcons/HomeActive'
import MenuSVG from 'components/atoms/SVGIcons/NewIcons/Directory'
import MenuActiveSVG from 'components/atoms/SVGIcons/NewIcons/DirectoryActive'
import UserSVG from 'components/atoms/SVGIcons/User'
import UserActiveSVG from 'components/atoms/SVGIcons/UserActive'
import HeartOutline from 'components/atoms/SVGIcons/HeartOutline'
import HeartActive from 'components/atoms/SVGIcons/HeartActive'
import AssessmentHistory from 'components/atoms/SVGIcons/AssessmentHistory'
import SearchSvg from 'components/atoms/SVGIcons/Search'
import BellOutline from 'components/atoms/SVGIcons/BellOutline'
import BellFull from 'components/atoms/SVGIcons/BellFull'

const getNewIcon = (name, color = '') => {
  switch (name) {
    case 'school':
      return <CampusSvg />
    case 'course':
      return <MajorSvg />
    case 'city':
      return <City />
    case 'province':
      return <Province />
    case 'campus-business':
      return <CareerSvg />
    case 'scholarship':
      return <ScholarshipSvg />
    case 'kampuspedia':
      return <KampuspediaSvg />
    case 'aptitude':
      return <AptitudeSvg />
    case 'learn':
      return <LearnSvg />
    case 'paperplane':
      return <PaperplaneSvg />
    case 'interest':
      return <InterestSvg />
    case 'logout':
      return <LogoutSvg />
    case 'arrow-left':
      return <ArrowLeftSvg />
    case 'right':
      return <RightSvg />
    case 'home':
      return <HomeSVG fill={color} />
    case 'homeActive':
      return <HomeActiveSVG fill={color} />
    case 'menu':
      return <MenuSVG fill={color} />
    case 'menuActive':
      return <MenuActiveSVG fill={color} />
    case 'user':
      return <UserSVG fill={color} />
    case 'userActive':
      return <UserActiveSVG fill={color} />
    case 'assessmentHistory':
      return <AssessmentHistory fill={color} />
    case 'heartOutline':
      return <HeartOutline fill={color} />
    case 'heartActive':
      return <HeartActive fill={color} />
    case 'search':
      return <SearchSvg />
    case 'bell':
      return <BellOutline fill={color} />
    case 'bellFull':
      return <BellFull fill={color} />
    default:
      return <CampusSvg />
  }
}

export default getNewIcon
